// Single source for the /subscriptions/plans FAQ: drives both the rendered
// accordion and the FAQPage JSON-LD, so the two never drift apart.
export default [
  {
    question: 'What experience is necessary to enroll?',
    answer: [
      'The Stan Winston School of Character Arts is open to anyone with a curious mind. No previous experience or education is required.'
    ]
  },
  {
    question: 'Is there a minimum time that I have to be a subscriber?',
    answer: [
      "There is no required amount of time you must stay a subscriber on our site. You have the option to cancel if you don't have sufficient time or funds to be a subscriber for the upcoming month."
    ]
  },
  {
    question: 'Are the on-demand courses available for download?',
    answer: [
      'Subscriptions give you access to streaming video available on our site. These cannot be downloaded. If you want a physical copy of any course you can purchase the individual course on DVD.'
    ]
  },
  {
    question: 'What forms of payment do you accept?',
    answer: ['We accept PayPal and credit card payments.']
  },
  {
    question: 'How long is the pay period?',
    answer: [
      'Our billing cycle for monthly subscriptions is 30 days. For our Annual subscription you will be charged the full amount once a year.'
    ]
  },
  {
    question: 'Is there an option not to auto-renew?',
    answer: [
      'All of our subscriptions are on Automatic Renewal. You can see when the next pay period occurs on your ACCOUNT page, so you will know when you will be charged again if you do not cancel your subscription.'
    ]
  },
  {
    question: "When can I cancel my account so it won't auto-renew?",
    answer: [
      'Once you receive the receipt for payment you are able to cancel your subscription and have access for the remaining time you have purchased.'
    ]
  },
  {
    question: 'Do you offer subscription discounts?',
    answer: [
      "Yes, we're happy to offer special discounts to full-time students and veterans of any nation with proof of eligibility. For more information, please contact us at info@stanwinstonschool.com."
    ]
  },
  {
    question:
      "What's the difference between a Live Course and an On-Demand course?",
    answer: [
      'The Live Courses feed our On-Demand Course Library. Eventually, all Live Courses are released into the Course Library and are available for all of our subscribers to watch.',
      'We are currently on schedule to release one course into the Course Library per month.',
      'We understand that Live Courses can be expensive. But if you are an Annual subscriber you can watch the Live Courses with a free reserved seat. It makes the Annual Subscription a fantastic value.',
      'You can sign up for a Live Course if you do not want to wait for the release into the Course library to watch the course material. Also, the Live Courses are a lot of fun, you can interact with the instructors and other students, ask questions and receive feedback from the artist.'
    ]
  }
]
